import { DiscountType, ReleaseType } from '@ibk/shared-types';
export function toOrderCalculationType(releaseType) {
    return releaseType === ReleaseType.DAILY ? 'DAILY' : 'MONTHLY';
}
export function toOrderDiscountType(discountType) {
    if (discountType === DiscountType.PERCENTAGE) {
        return 'PERCENTAGE';
    }
    if (discountType === DiscountType.TOTAL) {
        return 'FIXED_VALUE';
    }
    return undefined;
}
